import { Link } from "react-router-dom";
import hotel from "../../assets/hotel.png";
import walk from "../../assets/walk-smart.png";
import redtoolkit from "../../assets/redtoolkit.png";

const Projects = () => {
	return (
		<body className="main_container">
			<header className="header">
				<nav className="header__menu">
					<Link className="header__menu__link" to="/">
						Home
					</Link>
					<Link className="header__menu__link" to="/projects">
						Projects
					</Link>
					<Link className="header__menu__link" to="/blogs">
						Blogs
					</Link>
					<div className="dropdown">
						<Link className="header__menu__link" to="" data-bs-toggle="dropdown" aria-expanded="false">
							Explore
						</Link>
						<ul className="dropdown-menu">
							<Link className="dropdown-item" to="/ds">
								Data Structure
							</Link>
						</ul>
					</div>
				</nav>
			</header>
			<main className="presentation">
				<section className="presentation__content">
					<h1 className="presentation__content__title">
						Our React Native{" "}
						<strong className="title-highlighted">creation </strong>
					</h1>
					<p className="presentation__content__text">
						Prototype for Hacienda del Sol Hotel Scheduling App Our React Native
						project for Hacienda del Sol Hotel aims to streamline and automate
						the scheduling process for healers. The app provides an intuitive
						interface for the front desk staff, allowing them to easily view and
						manage the healer's calendar. Key features include.
						<strong className="title-highlighted">
							Automated Scheduling:
						</strong>{" "}
						Simplifies the process of assigning healer appointments, reducing
						manual errors and saving time.
						<strong className="title-highlighted">
							{" "}
							Real-Time Calendar:
						</strong>{" "}
						Provides a clear and updated view of the healer's schedule, ensuring
						efficient time management.{" "}
						<strong className="title-highlighted">
							Customer Management:
						</strong>{" "}
						Offers a comprehensive list of customers, making it easy to assign
						and track appointments.
					</p>
				</section>
				<img
					className="presentation__image__projects"
					src={hotel}
					alt="hotel-project-img"
				/>
			</main>

			<main className="presentation">
				<section className="presentation__content">
					<p className="presentation__content__text">
						<strong className="title-highlighted">Red Toolkit </strong>this is a mobile application
						designed to scan devices within a
						local network, providing network administrators with critical
						information to determine active and inactive devices.
						The app also features a Watch List functionality, incorporating ping
						capabilities, and a port scanner to identify open and closed ports on selected devices.
					</p>
				</section>
				<img
					className="presentation__image__projects"
					src={redtoolkit}
					alt="walk-smart-project-img"
				/>
			</main>

			<main className="presentation">
				<section className="presentation__content">
					<p className="presentation__content__text">
						<strong className="title-highlighted">Internal Project </strong>
						Walk Smart is a React Native application designed to enrich your
						walking experience by connecting you with live events and
						like-minded individuals around you. Whether you're waiting for a
						bus, train, or simply taking a stroll, Walk Smart helps you discover
						exciting events and people to share your passions with. Benefits:
						Turn your walking time into an opportunity for discovery and
						socializing. Stay informed about live events and activities
						happening around you. Meet new people, share experiences, and expand
						your network. Enhance your daily routine with meaningful connections
						and engaging activities.
					</p>
				</section>
				<img
					className="presentation__image__projects"
					src={walk}
					alt="walk-smart-project-img"
				/>
			</main>
			<footer className="footer">
				<p>Made by BinaryStack Labs &copy; 2025</p>
			</footer>
		</body>
	);
};

export default Projects;
